module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921055334_T.b234b855.jpg";